export default __webpack_public_path__ + "static/media/step-7.7e06ba94.jpg";